import { Link, TextSizes, Tooltip } from '@bitrise/bitkit';
import GitProvider, { getViewOnProviderText } from '@/models/GitProvider';
import BuildMetaData from '@/components/BuildListItem/BuildMetaData/BuildMetaData';

type PullRequestOrCommitHashLinkProps = {
  gitProvider?: GitProvider;
  commitHash?: string;
  commitHashUrl?: string;
  pullRequestId?: number;
  pullRequestUrl?: string;
  size?: TextSizes;
};

const PullRequestOrCommitHashLink = ({
  gitProvider,
  commitHash,
  commitHashUrl,
  pullRequestId,
  pullRequestUrl,
  size = '2',
}: PullRequestOrCommitHashLinkProps) => {
  if (pullRequestId && pullRequestId > 0) {
    return (
      <Tooltip label={getViewOnProviderText(gitProvider)}>
        <BuildMetaData textProps={{ whiteSpace: 'nowrap', size }} flexShrink={0}>
          {pullRequestUrl ? (
            <Link href={pullRequestUrl} isExternal whiteSpace="nowrap" colorScheme="purple" size={size}>
              #{pullRequestId}
            </Link>
          ) : (
            `#${pullRequestId}`
          )}
        </BuildMetaData>
      </Tooltip>
    );
  }

  if (commitHash) {
    const slicedCommitHash = commitHash.slice(0, 7);

    return (
      <Tooltip label={getViewOnProviderText(gitProvider)}>
        <BuildMetaData textProps={{ whiteSpace: 'nowrap', size }} flexShrink={0}>
          {commitHashUrl ? (
            <Link href={commitHashUrl} isExternal whiteSpace="nowrap" colorScheme="purple" size={size}>
              {slicedCommitHash}
            </Link>
          ) : (
            `${slicedCommitHash}`
          )}
        </BuildMetaData>
      </Tooltip>
    );
  }

  return null;
};

export default PullRequestOrCommitHashLink;
